import { whatsappConfigSchema } from './config-schema.js';

export const whatsappDefinition = {
  type: 'whatsapp',
  nameKey: 'nodes.whatsapp.name',
  subtitleKey: 'nodes.whatsapp.subtitle',
  modalTitleKey: 'nodes.whatsapp.title',
  icon: 'chat',
  color: '#25D366',
  colorGradient: 'linear-gradient(135deg, #25D366, #128C7E)',
  category: 'allApps',
  schema: whatsappConfigSchema
};
